/**
 *
 * CustomPageHeader
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { Link, useHistory } from 'react-router-dom';

import useDeviceDetect from 'utils/useDeviceDetect';

// styles
import './style.scss';

// antd component
import { PageHeader } from 'antd';

// icons
//import CustomIcons from 'components/CustomIcons';

// components
import LinkWrapper from 'components/LinkWrapper';

// global user
// import { withUser } from 'engine/Contexts/User.context';

function CustomPageHeader({ title, subTitle, breadcrumb, subTitlePosition, extraActions, className }) {
  //const { isMobile } = useDeviceDetect();
  const subClass = `${subTitlePosition ? 'sub-title-' + subTitlePosition : ''}`;
  const childClassNames = classNames('tcf-page-header', 'details-header', subClass, className);
  return (
    <PageHeader
      className={childClassNames}
      title={title}
      subTitle={subTitle}
      extra={extraActions}
      breadcrumb={{ breadcrumb }}
    />
  );
}

CustomPageHeader.propTypes = {
  subTitlePosition: PropTypes.oneOf(['top', 'bottom', 'middle']),
  extraActions: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.array,
  ]),
};

export default memo(CustomPageHeader);
